export enum CreditorSubCriterias {
  NAME = "Name",
  NUMBER = "Number",
  ADDRESS = "Address",
  GROUP_NUMBER = "Group Number",
  GROUP_NAME = "Group Name",
}
